import { FloorWorkstationRequest, WorkstationOccupancyRequest } from "../../api/generated";

const RESERVED = "Reserved";
const INTERN = "Intern";

export const readFloorWorkstations = (root: ParentNode): FloorWorkstationRequest[] => {
  const workstations: FloorWorkstationRequest[] = [];
  root.querySelectorAll("#tables g g polygon").forEach((polygon) => {
    const [prefix, workstationId, , roomId] = (polygon.getAttribute("id") ?? "").split("_");
    if (prefix !== "path" || workstations.some((workstation) => workstation.id === workstationId)) return;

    workstations.push({
      id: workstationId,
      roomId: Number(roomId),
      occupancy: readOccupancy(root, `${workstationId}_office_${roomId}`),
    });
  });
  return workstations;
};

const readOccupancy = (root: ParentNode, labelSuffix: string): WorkstationOccupancyRequest | undefined => {
  const user = root.querySelector(`[id="user_${labelSuffix}"]`);
  const username = user?.getAttribute("username");
  if (!user || !username) return undefined;

  const svgDisplayName = user.textContent ?? "";
  const svgOrganizationLabel = root.querySelector(`[id="company_${labelSuffix}"]`)?.textContent || undefined;
  const lastActiveDate = root.querySelector(`[id="date_${labelSuffix}"]`)?.getAttribute("last-active-date") || undefined;

  if (username === RESERVED) {
    const employeeId = user.getAttribute("reservation-employee-id")?.trim();
    return {
      type: "RESERVED",
      employeeId: employeeId ? Number(employeeId) : undefined,
      additionalInfo: employeeId ? undefined : additionalInfo(svgDisplayName, RESERVED),
      svgDisplayName,
      svgOrganizationLabel,
      lastActiveDate,
    };
  }
  if (username === INTERN) {
    return {
      type: "INTERN",
      additionalInfo: additionalInfo(svgDisplayName, INTERN),
      svgDisplayName,
      svgOrganizationLabel,
      lastActiveDate,
    };
  }
  return { type: "EMPLOYEE", username, svgDisplayName, svgOrganizationLabel };
};

// Same rule as the occupancy backfill, so unchanged labels match what is stored.
const additionalInfo = (displayText: string, kind: string): string | undefined => {
  const suffix = `\n(${kind})`;
  if (!displayText.endsWith(suffix)) return undefined;
  return displayText.slice(0, -suffix.length).trim() || undefined;
};
